// Configuration centralisée
const BLOC_CONFIG = {
  maxBlocs: 10,

  onduleur: {
    count: 0,
    step: 4,
    isSpecial: true,
    onFieldChange: updateOnduleursFileList
  },

  alternateur: {
    count: 0,
    step: 5,
    isSpecial: false,
  },

  // Fallback pour les types non définis
  default: {
    count: 0,
    isSpecial: false,
    maxMessage: (max, type) =>
      `<p>Vous ne pouvez pas ajouter plus de ${max} ${type}s. Vous pourrez fournir la liste complète plus tard, lors du traitement de votre demande.</p>`
  }
};

function getBlocTypeByStep(step) {
  const stepMapping = {
    4: 'onduleur',
    5: 'alternateur'
  };
  return stepMapping[step] || null;
}

// Fonctions utilitaires pures
const getBlocConfig = (type) => BLOC_CONFIG[type] ?? BLOC_CONFIG.default;

const createWarningMessage = (blocType, maxBlocs) => {
  const message = document.createElement('div');

  message.classList.add('hq-avertissement', 'hq-bloc-gris-top', 'js-message');
  message.innerHTML = BLOC_CONFIG.default.maxMessage(maxBlocs, blocType);

  return message;
};

const handleMaxLimitReached = (target, blocType) => {
  target.setAttribute("disabled", "disabled");
  const warningMessage = createWarningMessage(blocType, BLOC_CONFIG.maxBlocs);
  target.parentNode.insertBefore(warningMessage, target.nextSibling);
};

const createBlocWrapper = (bloc) => {
  const wrapper = document.createElement('div');
  wrapper.classList.add("marginbottom-20");
  wrapper.appendChild(bloc);
  return wrapper;
};

const setupRemoveButton = (wrapper, blocType, count, index = null) => {
  const removeBtn = wrapper.querySelector('.js-remove-bloc');
  if (!removeBtn) return;

  // Logique d'affichage unifiée
  const shouldHide = (index === 0 && count === 1) || count === 1;
  removeBtn.style.display = shouldHide ? 'none' : 'inline-block';

  // Attacher l'événement seulement si nécessaire
  if (count > 1 && !removeBtn.hasAttribute('data-event-attached')) {
    removeBtn.addEventListener('click', (ev) => removeBlocHandler(ev, blocType));
    removeBtn.setAttribute('data-event-attached', 'true');
  }
};

const setupSpecialHandlers = (wrapper, blocType) => {
  const config = getBlocConfig(blocType);
  if (!config.isSpecial) return;

  // Sélectionner TOUS les champs qui peuvent être validés
  const fields = wrapper.querySelectorAll(
    'input[type="text"], input[type="number"], select, input[type="radio"], input[type="checkbox"]'
  );

  fields.forEach(field => {
    // Événements différents selon le type de champ
    if (field.type === 'radio' || field.type === 'checkbox') {
      field.addEventListener('change', config.onFieldChange);
    } else {
      field.addEventListener('input', config.onFieldChange);
      field.addEventListener('change', config.onFieldChange);
      field.addEventListener('blur', config.onFieldChange);
    }
  });

  // Appeler une première fois pour initialiser
  config.onFieldChange();
};

function addBlocHandler(e) {
  const blocType = e.currentTarget.getAttribute("data-type");
  const currentCount = ++BLOC_CONFIG[blocType].count;

  // Gestion de la limite (early return)
  if (currentCount === BLOC_CONFIG.maxBlocs) {
    handleMaxLimitReached(e.currentTarget, blocType);
  }

  // Création du bloc
  const newBloc = createBlocFromTemplate(blocType, currentCount);
  if (!newBloc) return;

  // Assembly et insertion
  const wrapper = createBlocWrapper(newBloc);
  e.currentTarget.parentNode.insertBefore(wrapper, e.currentTarget);

  // Configuration des handlers
  setupRemoveButton(wrapper, blocType, currentCount);
  setupSpecialHandlers(wrapper, blocType);

  const blocElement = wrapper.querySelector(`.js-${blocType}`);
  if (blocElement) {
    initializeCheckboxesInBloc(blocElement);
  }
}

function addDefaultBloc(blocType) {

  BLOC_CONFIG[blocType].count = 1;

  const newBloc = createBlocFromTemplate(blocType, 1);

  if (!newBloc) {
    return;
  }

  // Trouver le container approprié
  const container = document.querySelector(`[data-hq-depends="${blocType}-oui"]`);
  const addButton = container ? container.querySelector(`.js-add-bloc[data-type="${blocType}"]`) : null;

  if (addButton) {
    const wrapper = document.createElement('div');

    wrapper.classList.add("marginbottom-20");
    wrapper.appendChild(newBloc);

    addButton.parentNode.insertBefore(wrapper, addButton);

    const removeBtn = wrapper.querySelector('.js-remove-bloc');
    if (removeBtn) {
      removeBtn.style.display = 'none';
    }
    // Attacher les événements pour onduleurs
    if (blocType === 'onduleur') {
      const fields = wrapper.querySelectorAll('input[type="text"]');
      fields.forEach(field => {
        field.addEventListener('change', updateOnduleursFileList);
      });

      updateOnduleursFileList();
    }
    const blocElement = wrapper.querySelector(`.js-${blocType}`);
    if (blocElement) {
      initializeCheckboxesInBloc(blocElement);
    }
  }
}

function removeBlocHandler(ev, blocType) {
  const bloc = ev.target.closest('.marginbottom-20');
  if (bloc) {
    // Ne pas permettre la suppression s'il ne reste qu'un seul bloc
    const existingBlocs = document.querySelectorAll(`.js-${blocType}`);
    if (existingBlocs.length <= 1) {
      return;
    }

    const fieldsToRemove = bloc.querySelectorAll('[name]');
    fieldsToRemove.forEach(field => {
      if (field.name) {
        try {
          $('#sefcoForm').formValidation('removeField', field.name);
        } catch (e) {
          // Le champ pourrait ne pas être dans FormValidation
          console.warn('Erreur lors de la suppression du champ de FormValidation:', field.name, e);
        }
      }
    });

    bloc.remove();
    BLOC_CONFIG[blocType].count--;

    // Réactiver le bouton d'ajout si nécessaire
    const addButton = document.querySelector(`.js-add-bloc[data-type="${blocType}"]`);

    if (addButton && addButton.hasAttribute("disabled")) {
      addButton.removeAttribute("disabled");
    }

    // Supprimer le message d'erreur si présent
    const message = document.querySelector('.js-message');
    if (message) {
      message.remove();
    }

    // Renuméroter les blocs restants
    renumberBlocs(blocType);

    // Réafficher le bouton de suppression du premier bloc s'il y a maintenant plus d'un bloc
    updateRemoveButtonsVisibility(blocType);

    if (blocType === 'onduleur') {
      updateOnduleursFileList();
      // Nettoyer les fichiers sauvegardés des onduleurs supprimés
      if (typeof window.cleanupOnduleurFiles === 'function') {
        window.cleanupOnduleurFiles();
      }
    }
  }
}

function updateRemoveButtonsVisibility(blocType) {
  const blocs = document.querySelectorAll(`.js-${blocType}`);

  blocs.forEach((bloc, index) => {
    setupRemoveButton(bloc, blocType, blocs.length, index);
  });
}

function createBlocFromTemplate(blocType, numero) {

  // Fonctions utilitaires locales
  const getTemplate = () => {
    const templateId = `template-${blocType}-html`;
    return document.getElementById(templateId);
  };

  const cloneAndFindBloc = (template) => {
    const clone = template.content.cloneNode(true);
    return clone.querySelector(`.js-${blocType}`);
  };

  const updateElementsNumbering = (blocElement) => {
    const elementsWithoutNumbers = blocElement.querySelectorAll(
      '[id]:not([id*="-1"]), [name]:not([name*="-1"])'
    );

    elementsWithoutNumbers.forEach(element => {
      const shouldUpdateId = element.id &&
        element.id.includes(blocType) &&
        !element.id.match(/-\d+$/);

      const shouldUpdateName = element.name &&
        element.name.includes(blocType) &&
        !element.name.match(/-\d+$/) &&
        !element.name.match(/_\w+-\d+$/);

      if (shouldUpdateId) {
        element.id = `${element.id}-${numero}`;
      }

      if (shouldUpdateName) {
        element.name = `${element.name}-${numero}`;
      }
    });
  };

  const initializeComponents = (blocElement) => {
    setTimeout(() => {
      initializeHqDepends(blocElement);
      initializeFieldValidation(blocElement);
      reinitializeFormValidation(blocElement);
      activateTemplateFieldsValidation(blocElement);
    }, 50);
  };

  // Logic principale
  const template = getTemplate();
  if (!template) {
    console.error(`Template template-${blocType}-html non trouvé`);
    return null;
  }

  const blocElement = cloneAndFindBloc(template);
  if (!blocElement) {
    console.error(`Élément .js-${blocType} non trouvé dans le template`);
    return null;
  }

  // Exécution des opérations
  updateBlocAttributes(blocElement, 1, numero, blocType);
  updateElementsNumbering(blocElement);
  initializeComponents(blocElement);

  return blocElement;
}

function updateBlocAttributes(bloc, oldNum, newNum, blocType) {
  // Cas spéciaux qui ne suivent pas le pattern standard
  const SPECIAL_CASES = ['tension-autre-2', 'type-autre', 'tension-alternateur-autre'];

  function transformValue(value, isNameAttribute = false) {
    // Cas spéciaux
    if (SPECIAL_CASES.includes(value)) {
      return `${value}-${newNum}`;
    }

    // Se termine par -oldNum (remplacement)
    if (value.endsWith(`-${oldNum}`)) {
      return value.replace(`-${oldNum}`, `-${newNum}`);
    }

    // Pattern underscore pour les names
    if (isNameAttribute && value.match(new RegExp(`_${blocType}-${oldNum}$`))) {
      return value.replace(`_${blocType}-${oldNum}`, `_${blocType}-${newNum}`);
    }

    // Template (transformation complète)
    if (value.includes(`template-${blocType}`)) {
      return value.replace(`template-${blocType}`, `${blocType}-${newNum}`);
    }

    // **RÈGLE SIMPLE** : Si pas de numéro à la fin, on ajoute -newNum
    if (!value.match(/-\d+$/) && (!isNameAttribute || !value.match(/_\w+-\d+$/))) {
      return `${value}-${newNum}`;
    }

    return value;
  }

  function updateAttribute(element, attr, isName = false) {
    const original = element.getAttribute(attr);
    const transformed = transformValue(original, isName);
    if (transformed !== original) {
      element.setAttribute(attr, transformed);
    }
  }

  // === Mises à jour ===
  if (bloc.id) {
    bloc.id = transformValue(bloc.id);
  }
  bloc.setAttribute('data-num', newNum);

  // Titre
  const heading = bloc.querySelector('h3');
  if (heading) {
    const title = blocType === 'onduleur' ? 'Onduleur' : 'Alternateur';
    heading.textContent = `${title} ${newNum}`;
  }

  // Mise à jour de TOUS les attributs qui doivent être uniques
  bloc.querySelectorAll('[id]').forEach(el => updateAttribute(el, 'id'));
  bloc.querySelectorAll('[name]').forEach(el => updateAttribute(el, 'name', true));
  bloc.querySelectorAll('label[for]').forEach(el => updateAttribute(el, 'for'));
  bloc.querySelectorAll('[data-hq-depends]').forEach(el => updateAttribute(el, 'data-hq-depends'));

  setTimeout(() => initializeHqDepends(bloc), 100);
}

function renumberBlocs(blocType) {
  const selector = blocType === 'onduleur' ? '.js-onduleur' : '.js-alternateur';
  const blocs = document.querySelectorAll(selector);

  if (blocs.length === 0) {
    BLOC_CONFIG[blocType].count = 0;
    return;
  }

  blocs.forEach((bloc, index) => {
    const newNum = index + 1;
    const oldNum = bloc.getAttribute('data-num') || (index + 2);
    updateBlocAttributes(bloc, oldNum, newNum, blocType);
  });

  BLOC_CONFIG[blocType].count = blocs.length;
  updateRemoveButtonsVisibility(blocType);
}

function updateElementReferences(bloc, oldNum, newNum, blocType) {
  // Regex réutilisables
  const patterns = {
    number: new RegExp(`-${oldNum}(?![0-9])`, 'g'),
    blocType: new RegExp(`_${blocType}-${oldNum}(?![0-9])`, 'g')
  };

  const replacements = {
    number: `-${newNum}`,
    blocType: `_${blocType}-${newNum}`
  };

  // Configuration des attributs à mettre à jour
  const attributeUpdates = [
    {
      selector: '[id]',
      getAttribute: (el) => el.id,
      setAttribute: (el, value) => { el.id = value; },
      patterns: ['number']
    },
    {
      selector: '[name]',
      getAttribute: (el) => el.name,
      setAttribute: (el, value) => { el.name = value; },
      patterns: ['number', 'blocType']
    },
    {
      selector: 'label[for]',
      getAttribute: (el) => el.getAttribute('for'),
      setAttribute: (el, value) => el.setAttribute('for', value),
      patterns: ['number']
    },
    {
      selector: '[data-hq-depends]',
      getAttribute: (el) => el.getAttribute('data-hq-depends'),
      setAttribute: (el, value) => el.setAttribute('data-hq-depends', value),
      patterns: ['number']
    }
  ];

  // Fonction utilitaire pour appliquer les remplacements
  const applyReplacements = (value, patternsToApply) => {
    return patternsToApply.reduce((result, patternName) => {
      return result.replace(patterns[patternName], replacements[patternName]);
    }, value);
  };

  // Mise à jour de tous les attributs
  attributeUpdates.forEach(({ selector, getAttribute, setAttribute, patterns: patternsToApply }) => {
    bloc.querySelectorAll(selector).forEach(element => {
      const originalValue = getAttribute(element);
      const updatedValue = applyReplacements(originalValue, patternsToApply);
      setAttribute(element, updatedValue);
    });
  });
}

function updateOnduleursFileList() {
  const fileListContainer = document.querySelector('.js-liste-fichiers li:nth-child(2) ul');

  if (!fileListContainer) return;

  // Vider la liste actuelle
  fileListContainer.innerHTML = '';

  // Vérifier si des onduleurs sont activés
  const onduleurOui = document.getElementById('onduleur-oui');
  const hasOnduleurs = onduleurOui && onduleurOui.checked;
  if (!hasOnduleurs) {
    return;
  }

  // Récupérer tous les blocs d'onduleurs de manière dynamique
  const onduleursElements = document.querySelectorAll('.js-onduleur');
  let onduleursActifs = [];

  onduleursElements.forEach((onduleurElement, index) => {
    // Vérifier si l'onduleur est visible
    if (window.getComputedStyle(onduleurElement).display !== 'none') {
      // Déterminer l'index basé sur data-num ou position
      const dataNum = onduleurElement.getAttribute('data-num');
      const onduleurIndex = dataNum ? parseInt(dataNum) : index + 1;
      // Chercher les champs de manière dynamique dans ce bloc
      const fabricantField = onduleurElement.querySelector('[id*="fabricant-onduleur"]');
      const modeleField = onduleurElement.querySelector('[id*="modele-onduleur"]');
      const fournisseurField = onduleurElement.querySelector('[id*="fournisseur-onduleur"]');
      const firmwareField = onduleurElement.querySelector('[id*="version-firmware"]');
      onduleursActifs.push({
        index: onduleurIndex,
        element: onduleurElement,
        fabricant: fabricantField,
        modele: modeleField,
        fournisseur: fournisseurField,
        firmware: firmwareField
      });
    }
  });

  // Si aucun onduleur actif, sortir
  if (onduleursActifs.length === 0) {
    return;
  }

  // Créer les éléments de liste pour chaque onduleur actif
  onduleursActifs.forEach(onduleur => {
    // Vérifier si au moins un des champs a une valeur
    const hasValue =
      (onduleur.fabricant && onduleur.fabricant.value) ||
      (onduleur.modele && onduleur.modele.value) ||
      (onduleur.fournisseur && onduleur.fournisseur.value) ||
      (onduleur.firmware && onduleur.firmware.value);

    if (hasValue) {
      const onduleurItem = document.createElement('li');
      onduleurItem.innerHTML = `
        Onduleur ${onduleur.index} :
        <ul>
          <li>Fabricant : ${onduleur.fabricant && onduleur.fabricant.value ? onduleur.fabricant.value : 'Non spécifié'}</li>
          <li>Modèle : ${onduleur.modele && onduleur.modele.value ? onduleur.modele.value : 'Non spécifié'}</li>
          <li>Fournisseur : ${onduleur.fournisseur && onduleur.fournisseur.value ? onduleur.fournisseur.value : 'Non spécifié'}</li>
          <li>Version du micrologiciel : ${onduleur.firmware && onduleur.firmware.value ? onduleur.firmware.value : 'Non spécifié'}</li>
        </ul>
      `;
      fileListContainer.appendChild(onduleurItem);
    }
  });
}

function initializeDefaultBlocs() {
  const setupBlocToggle = (blocType) => {
    const element = document.getElementById(`${blocType}-oui`);

    element?.addEventListener('change', (e) => {
      if (e.target.checked && document.querySelectorAll(`.js-${blocType}`).length === 0) {
        addDefaultBloc(blocType);
      }
    });
  };

  ['onduleur', 'alternateur'].forEach(setupBlocToggle);
}

function setupOnduleurListListeners() {

  // 1. Observer les changements dans la section des onduleurs
  const onduleursContainer = document.querySelector('.js-blocs-onduleur') || document.querySelector('.etape-section');
  if (onduleursContainer) {
    const observer = new MutationObserver(function () {
      setTimeout(updateOnduleursFileList, 100);
    });
    observer.observe(onduleursContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // 2. Écouter les changements dans les inputs des onduleurs
  document.addEventListener('change', function (e) {
    if (e.target && (
      e.target.id.includes('fabricant-onduleur') ||
      e.target.id.includes('modele-onduleur') ||
      e.target.id.includes('fournisseur-onduleur') ||
      e.target.id.includes('version-firmware')
    )) {
      updateOnduleursFileList();
    }
  });

  // 3. Écouter les clics sur les boutons d'ajout/suppression d'onduleurs
  document.addEventListener('click', function (e) {
    if (e.target && (
      e.target.classList.contains('js-add-bloc') ||
      e.target.classList.contains('js-remove-bloc')
    )) {
      setTimeout(updateOnduleursFileList, 200);
    }
  });

  // 4. Écouter le changement de statut onduleur oui/non
  const onduleurRadios = document.querySelectorAll('input[name="onduleur"]');
  onduleurRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      setTimeout(updateOnduleursFileList, 100);
    });
  });
}

function observeNewBlocs() {
  // Observer les changements dans les sections d'onduleurs et alternateurs
  const onduleurSection = document.querySelector('[data-hq-depends="onduleur-oui"]');
  const alternateurSection = document.querySelector('[data-hq-depends="alternateur-oui"]');
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Si c'est un nouveau bloc onduleur/alternateur
            if (node.classList && node.classList.contains('marginbottom-20')) {
              const blocElement = node.querySelector('.js-onduleur, .js-alternateur');
            }
          }
        });
      }
    });
  });
  if (onduleurSection) {
    observer.observe(onduleurSection, { childList: true, subtree: true });
  }
  if (alternateurSection) {
    observer.observe(alternateurSection, { childList: true, subtree: true });
  }
}

function initializeHqDepends(bloc) {
  const elementsWithDepends = bloc.querySelectorAll('[data-hq-depends]');
  elementsWithDepends.forEach(dependentElement => {
    const dependsValue = dependentElement.getAttribute('data-hq-depends');
    // Chercher l'élément déclencheur d'abord dans le bloc local, puis globalement
    let triggerElement = bloc.querySelector(`#${dependsValue}`);
    if (!triggerElement) {
      triggerElement = document.getElementById(dependsValue);
    }
    if (triggerElement) {

      const blocId = bloc.querySelector('.js-onduleur, .js-alternateur')?.id || 'global';
      const eventKey = `hq-depends-${dependsValue}-${blocId}`;

      const checkVisibility = () => {
        let shouldShow = false;

        // Si c'est un radio button, on doit vérifier s'il est spécifiquement sélectionné
        if (triggerElement.type === 'radio') {
          shouldShow = triggerElement.checked;
        } else if (triggerElement.type === 'checkbox') {
          shouldShow = triggerElement.checked;
        } else if (triggerElement.tagName === 'SELECT') {
          shouldShow = triggerElement.value && triggerElement.value !== '';
        } else {
          shouldShow = triggerElement.value && triggerElement.value.trim() !== '';
        }
        dependentElement.style.display = shouldShow ? 'block' : 'none';

        // Si caché, vider les champs requis à l'intérieur
        if (!shouldShow) {
          const requiredFields = dependentElement.querySelectorAll('[required]');
          requiredFields.forEach(field => {
            if (field.type === 'radio' || field.type === 'checkbox') {
              field.checked = false;
            } else {
              field.value = '';
            }
            try {
              $('#sefcoForm').formValidation('enableFieldValidators', field.name, false);
            } catch (e) {
              // FormValidation pourrait ne pas être initialisé encore
            }
          });
        } else {
          // La validation sera activée lors de l'interaction utilisateur ou de la soumission
          const requiredFields = dependentElement.querySelectorAll('[required]');
          requiredFields.forEach(field => {
            // Nettoyer les messages d'erreur personnalisés mais ne pas activer FormValidation
            field.setCustomValidity('');
          });
        }
      };

      // Si c'est un radio button, on doit écouter TOUS les radio buttons du même groupe
      if (triggerElement.type === 'radio') {
        const radioGroupName = triggerElement.name;
        const radioGroup = bloc.querySelectorAll(`input[type="radio"][name="${radioGroupName}"]`);

        // Supprimer les anciens événements pour éviter les doublons
        radioGroup.forEach(radio => {
          if (radio[eventKey]) {
            radio.removeEventListener('change', radio[eventKey]);
          }
        });

        // Attacher les événements à tous les radio buttons du groupe
        radioGroup.forEach(radio => {
          radio[eventKey] = checkVisibility;
          radio.addEventListener('change', checkVisibility);
        });
      } else {
        // Pour les autres types d'éléments, comportement normal
        // Supprimer les anciens événements pour éviter les doublons
        if (triggerElement[eventKey]) {
          triggerElement.removeEventListener('change', triggerElement[eventKey]);
          triggerElement.removeEventListener('input', triggerElement[eventKey]);
        }

        // Stocker la fonction pour pouvoir la supprimer plus tard
        triggerElement[eventKey] = checkVisibility;
        // Attacher les événements
        triggerElement.addEventListener('change', checkVisibility);
        triggerElement.addEventListener('input', checkVisibility);
      }

      // Vérifier la visibilité initiale avec un délai pour laisser le DOM se stabiliser
      setTimeout(checkVisibility, 100);
    } else {
      console.warn(`Élément de référence non trouvé pour data-hq-depends: ${dependsValue} dans le bloc`, bloc);
    }
  });
}

function initializeFieldValidation(bloc) {
  const requiredFields = bloc.querySelectorAll('[required]');

  requiredFields.forEach(field => {
    const validateField = () => {
      const fieldContainer = field.closest('.groupe-champs') || field.closest('fieldset') || field.parentElement;
      const isVisible = window.getComputedStyle(field).display !== 'none' &&
        window.getComputedStyle(fieldContainer).display !== 'none';

      if (!isVisible) {
        field.setCustomValidity('');
        fieldContainer.classList.remove('hq-has-error');
        try {
          $('#sefcoForm').formValidation('enableFieldValidators', field.name, false);
        } catch (e) {}
        return true;
      }

      let isValid = false;
      if (field.type === 'radio') {
        const radioGroup = document.querySelectorAll(`input[name="${field.name}"]`);
        isValid = Array.from(radioGroup).some(radio => radio.checked);
      } else if (field.type === 'checkbox') {
        if (field.name.includes('[]')) {
          const checkboxGroup = document.querySelectorAll(`input[name="${field.name}"]`);
          isValid = Array.from(checkboxGroup).some(checkbox => checkbox.checked);
        } else {
          isValid = field.checked;
        }
      } else {
        isValid = field.value && field.value.trim() !== '';
      }

      // Mettre à jour uniquement les classes visuelles, pas FormValidation
      if (!isValid) {
        field.setCustomValidity(field.getAttribute('data-fv-message') || 'Ce champ est requis.');
        fieldContainer.classList.add('hq-has-error');
      } else {
        field.setCustomValidity('');
        fieldContainer.classList.remove('hq-has-error');
      }

      // NE PAS revalider automatiquement - cela sera fait au submit
      // Cette suppression évite les erreurs qui apparaissent brièvement avant le changement de page

      return isValid;
    };

    // Attacher les événements
    field.addEventListener('change', validateField);
    field.addEventListener('input', validateField);
    field.addEventListener('blur', validateField);
  });
}

function reinitializeFormValidation(bloc) {
  // Vérifier que FormValidation est disponible
  if (typeof $.fn.formValidation === 'undefined') {
    console.warn('FormValidation plugin not available');
    return;
  }

  // Réinitialiser tous les champs requis dans le bloc pour FormValidation
  const requiredFields = bloc.querySelectorAll('[required]');
  requiredFields.forEach(field => {
    const fieldName = field.name;
    const fieldId = field.id;

    if (!fieldName || !fieldId) return;

    // Configuration de base pour tous les champs requis
    const validators = {
      notEmpty: {
        message: field.getAttribute('data-fv-message') || 'Ce champ est requis.'
      }
    };

    // Ajouter des validateurs spécifiques selon le type de champ
    if (field.type === 'number') {
      validators.numeric = {
        message: 'Veuillez entrer un nombre valide.'
      };
    }

    if (field.type === 'email') {
      validators.emailAddress = {
        message: 'Veuillez entrer une adresse e-mail valide.'
      };
    }

    // Ajouter le champ à FormValidation
    try {
      $('#sefcoForm').formValidation('addField', fieldName, {
        validators: validators
      });

      // Les champs des templates ne sont pas validés lors de l'ajout, seulement lors de la soumission
      $('#sefcoForm').formValidation('enableFieldValidators', fieldName, false);
    } catch (e) {
      console.warn('Erreur lors de l\'ajout du champ à FormValidation:', fieldName, e);
    }
  });

  // Gérer spécifiquement les groupes de radio buttons
  const radioGroups = {};
  bloc.querySelectorAll('input[type="radio"][required]').forEach(radio => {
    const groupName = radio.name;
    if (!radioGroups[groupName]) {
      radioGroups[groupName] = [];
    }
    radioGroups[groupName].push(radio);
  });

  Object.keys(radioGroups).forEach(groupName => {
    try {
      $('#sefcoForm').formValidation('addField', groupName, {
        validators: {
          notEmpty: {
            message: radioGroups[groupName][0].getAttribute('data-fv-message') || 'Veuillez faire une sélection.'
          }
        }
      });

      $('#sefcoForm').formValidation('enableFieldValidators', groupName, false);
    } catch (e) {
      console.warn('Erreur lors de l\'ajout du groupe radio à FormValidation:', groupName, e);
    }
  });

  // Gérer spécifiquement les groupes de checkboxes
  const checkboxGroups = {};
  bloc.querySelectorAll('input[type="checkbox"][required]').forEach(checkbox => {
    const groupName = checkbox.name;
    if (!checkboxGroups[groupName]) {
      checkboxGroups[groupName] = [];
    }
    checkboxGroups[groupName].push(checkbox);
  });

  Object.keys(checkboxGroups).forEach(groupName => {
    try {
      $('#sefcoForm').formValidation('addField', groupName, {
        validators: {
          choice: {
            min: 1,
            message: checkboxGroups[groupName][0].getAttribute('data-fv-message') || 'Veuillez sélectionner au moins une option.'
          }
        }
      });

      $('#sefcoForm').formValidation('enableFieldValidators', groupName, false);
    } catch (e) {
      console.warn('Erreur lors de l\'ajout du groupe checkbox à FormValidation:', groupName, e);
    }
  });
}

function activateTemplateFieldsValidation(bloc) {
  // Activer immédiatement la validation pour les champs requis du template
  const requiredFields = bloc.querySelectorAll('[required]');
  requiredFields.forEach(field => {
    if (field.name && isFieldVisible(field)) {
      try {
        // Activer la validation FormValidation pour ce champ
        $('#sefcoForm').formValidation('enableFieldValidators', field.name, true);
      } catch (e) {
        console.warn('Erreur lors de l\'activation de la validation du template:', field.name, e);
      }
    }
  });
  // Gérer spécifiquement les groupes de radio buttons
  const radioGroups = {};
  bloc.querySelectorAll('input[type="radio"][required]').forEach(radio => {
    const groupName = radio.name;
    if (!radioGroups[groupName]) {
      radioGroups[groupName] = [];
    }
    radioGroups[groupName].push(radio);
  });
  Object.keys(radioGroups).forEach(groupName => {
    try {
      $('#sefcoForm').formValidation('enableFieldValidators', groupName, true);
    } catch (e) {
      console.warn('Erreur lors de l\'activation de la validation du groupe radio du template:', groupName, e);
    }
  });
  // Gérer spécifiquement les groupes de checkboxes
  const checkboxGroups = {};
  bloc.querySelectorAll('input[type="checkbox"][required]').forEach(checkbox => {
    const groupName = checkbox.name;
    if (!checkboxGroups[groupName]) {
      checkboxGroups[groupName] = [];
    }
    checkboxGroups[groupName].push(checkbox);
  });
  Object.keys(checkboxGroups).forEach(groupName => {
    try {
      $('#sefcoForm').formValidation('enableFieldValidators', groupName, true);
    } catch (e) {
      console.warn('Erreur lors de l\'activation de la validation du groupe checkbox du template:', groupName, e);
    }
  });
}

function activateAllValidation() {
  // Activer la validation pour tous les champs requis visibles
  const allRequiredFields = document.querySelectorAll('[required]');

  allRequiredFields.forEach(field => {
    if (field.name && isFieldVisible(field)) {
      try {
        $('#sefcoForm').formValidation('enableFieldValidators', field.name, true);
      } catch (e) {
        console.warn('Erreur lors de l\'activation de la validation:', field.name, e);
      }
    }
  });
}

function activateTemplateValidation(step) {
  const blocType = getBlocTypeByStep(step);
  if (!blocType) {
    console.warn(`Aucun type de bloc configuré pour l'étape ${step}`);
    return false;
  }

  const fieldsToValidate = Array.from(document.querySelectorAll(`.js-${blocType}`))
    .flatMap(bloc => Array.from(bloc.querySelectorAll('[required]')))
    .filter(field => field.name && isFieldVisible(field));

  fieldsToValidate.forEach(field => {
    try {
      $('#sefcoForm').formValidation('enableFieldValidators', field.name, true);
    } catch (e) {
      console.warn('Erreur lors de l\'activation de la validation du template:', field.name, e);
    }
  });

  return fieldsToValidate.length > 0;
}

// Fonction pour mettre à jour UN groupe de checkboxes spécifique
function updateCheckboxConcatField(checkboxName) {
  const form = document.getElementById('sefcoForm');

  if (!form) return;

  const checkboxes = form.querySelectorAll(`input[type="checkbox"][name="${checkboxName}"]`);
  if (checkboxes.length === 0) return;

  // Convertir "type-energie[]" en "type_energie_concat"
  const baseName = checkboxName.replace('[]', '').replace(/-/g, '_');

  const match = baseName.match(/^(.+)_(\d+)$/);
  const hiddenName = match
    ? `${match[1]}_concat-${match[2]}`
    : `${baseName}_concat`;

  // Récupérer toutes les valeurs cochées
  const checkedBoxes = Array.from(checkboxes)
    .filter(cb => cb.checked)
    .map(cb => cb.value);

  // Chercher le champ caché existant
  let hiddenInput = form.querySelector(`input[name="${hiddenName}"]`);

  if (checkedBoxes.length === 0) {
    if (hiddenInput) {
      hiddenInput.remove();
    }
    return;
  }

  if (!hiddenInput) {
    hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = hiddenName;
    hiddenInput.id = hiddenName;
    form.appendChild(hiddenInput);
  }

  hiddenInput.value = checkedBoxes.join(', ');
}

// Initialiser les checkboxes dans un bloc spécifique (pour les templates dynamiques)
function initializeCheckboxesInBloc(bloc) {
  const checkboxes = bloc.querySelectorAll('input[type="checkbox"]');

  checkboxes.forEach(checkbox => {
    const name = checkbox.name;

    if (name && name.includes('[]')) {

      checkbox.addEventListener('change', function () {
        updateCheckboxConcatField(name);
      });
    }
  });

  // Initialiser les champs concat pour les checkboxes déjà cochées
  const checkboxGroups = new Set();
  checkboxes.forEach(checkbox => {
    const name = checkbox.name;
    if (name && name.includes('[]')) {
      checkboxGroups.add(name);
    }
  });

  checkboxGroups.forEach(groupName => {
    updateCheckboxConcatField(groupName);
  });
}

// Initialiser les listeners sur tous les checkboxes statiques
function initializeCheckboxListeners() {
  const form = document.getElementById('sefcoForm');
  if (!form) return;

  const checkboxGroups = new Set();

  form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
    const name = checkbox.name;

    if (name && name.includes('[]')) {
      checkboxGroups.add(name);

      checkbox.addEventListener('change', function () {
        updateCheckboxConcatField(name);
      });
    }
  });

  checkboxGroups.forEach(groupName => {
    updateCheckboxConcatField(groupName);
  });
}

function getCurrentStep() {
  // Détecter l'étape actuelle (vous devrez adapter cette fonction selon votre système d'étapes)
  const currentEtape = document.querySelector('.etape.active, .step.active');
  if (currentEtape) {
    const stepNumber = currentEtape.getAttribute('data-step') ||
      currentEtape.getAttribute('data-etape') ||
      currentEtape.classList.toString().match(/etape-(\d+)/)?.[1] ||
      currentEtape.classList.toString().match(/step-(\d+)/)?.[1];
    return stepNumber ? parseInt(stepNumber) : null;
  }

  // Alternative: chercher dans l'URL ou d'autres indicateurs
  const urlParams = new URLSearchParams(window.location.search);
  const stepParam = urlParams.get('step') || urlParams.get('etape');
  if (stepParam) {
    return parseInt(stepParam);
  }

  return null;
}

function isFieldVisible(field) {
  const fieldContainer = field.closest('.groupe-champs') || field.closest('fieldset') || field.parentElement;
  return window.getComputedStyle(field).display !== 'none' &&
    window.getComputedStyle(fieldContainer).display !== 'none';
}

document.addEventListener('DOMContentLoaded', function () {
  const noSpaceFields = document.querySelectorAll('.js-no-space');

  noSpaceFields.forEach(field => {
    field.addEventListener('blur', function() {
      this.value = this.value.replace(/\s+/g, '');
    });
  });

  const handleValidation = () => {
    const currentStep = getCurrentStep();
    const shouldUseTemplateValidation = currentStep === 4 || currentStep === 5;

    if (shouldUseTemplateValidation) {
      activateTemplateValidation(currentStep);
    } else {
      activateAllValidation();
    }
  };

  const isSubmitButton = (target) => {
    return ['btn-suivant', 'btn-next'].some(cls => target.classList.contains(cls)) ||
      target.type === 'submit' ||
      (target.tagName === 'BUTTON' && target.form);
  };

  // === Initialisations de base ===
  initializeDefaultBlocs();
  updateOnduleursFileList();
  setupOnduleurListListeners();
  observeNewBlocs();
  initializeCheckboxListeners();

  // === Boutons d'ajout existants ===
  document.querySelectorAll('.js-add-bloc').forEach(button => {
    button.addEventListener('click', addBlocHandler);
  });

  // === Template onduleur initial ===
  const templateOnduleur = document.getElementById('template-onduleur');
  if (templateOnduleur) {
    templateOnduleur.querySelectorAll('input[type="text"]').forEach(field => {
      field.addEventListener('change', updateOnduleursFileList);
    });
  }

  // === Validation du formulaire ===
  const form = document.getElementById('sefcoForm');
  if (form) {
    // Submit direct
    form.addEventListener('submit', (e) => {
      handleValidation();
    });
  }

  // Mise à jour finale
  updateOnduleursFileList();
});

function revalidateAlternateurFields() {
  // Cette fonction sera appelée à chaque changement de champ dans un alternateur
  const alternateurBlocs = document.querySelectorAll('.js-alternateur');

  alternateurBlocs.forEach(bloc => {
    const fields = bloc.querySelectorAll('input[required], select[required]');

    fields.forEach(field => {
      if (field.value && field.value.trim() !== '') {
        // Retirer la classe d'erreur si le champ a une valeur
        const fieldContainer = field.closest('.groupe-champs') || field.closest('fieldset');
        if (fieldContainer) {
          fieldContainer.classList.remove('hq-has-error');
        }

        // Revalider avec FormValidation
        if (field.name) {
          try {
            $('#sefcoForm').formValidation('revalidateField', field.name);
          } catch (e) {
            console.warn('Erreur revalidation:', field.name, e);
          }
        }
      }
    });
  });
}
